"use client";

import { useSelectedLayoutSegment } from "next/navigation";
import { CSSProperties, ReactNode, useEffect, useRef, useState } from "react";

import { BrandHeader } from "../../../libs/ui/brand-header/brand-header";
import { LoyaltyLayout } from "../../../libs/ui/loyalty-layout/loyalty-layout";

export interface ILayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: ILayoutProps) => {
  const segment = useSelectedLayoutSegment();

  const headerRef = useRef<HTMLElement | null>(null);

  const [styleVariables, setStyleVariables] = useState({
    "--header-height": `4.5rem`,
  } as CSSProperties);

  useEffect(() => {
    const handleResize = () => {
      if (headerRef.current) {
        setStyleVariables({
          "--header-height": `${headerRef.current.clientHeight}px`,
        } as CSSProperties);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // TODO: Change to more robust condition when more segments with new layout are added
  if (segment === "register") return <LoyaltyLayout>{children}</LoyaltyLayout>;

  return (
    <>
      <main className={"bg-blue-B500 h-full w-full"} style={styleVariables}>
        <header
          ref={headerRef}
          className={
            "flex min-h-[4.5rem] w-full items-center justify-start px-6 py-3"
          }
        >
          <BrandHeader />
        </header>

        <div
          className={"container mx-auto h-[calc(100dvh-var(--header-height))]"}
        >
          {children}
        </div>
      </main>
    </>
  );
};

export default Layout;
